<template>
  <Modal
    :show="showError"
    :title="$t('errors.timeout_title')"
    :width="500"
    allow-backdrop-close
    @close="hide"
  >
    <div class="py-4 text-center">
      <!-- Design-system look: the same symbol as every alert (Alert.vue, illustration "attention"). -->
      <img
        v-if="designSystem"
        :src="Vapor.asset('images/ds-illustrations/attention.svg')"
        alt=""
        class="mx-auto mb-3.5 size-24"
      />
      <FontAwesomeIcon
        v-else
        :icon="['fal', 'exclamation-triangle']"
        class="mb-4 text-4xl text-yellow-500"
      />
      <p class="text-body text-fg">
        {{
          isTablePage
            ? $t('errors.timeout_table_message')
            : $t('errors.timeout_message')
        }}
      </p>
      <button
        type="button"
        class="mt-6 cursor-pointer rounded-lg bg-primary px-6 py-2 text-white"
        :class="designSystem && 'app-btn app-btn--brand'"
        @click="hide"
      >
        {{ $t('common.close') }}
      </button>
    </div>
  </Modal>
</template>

<script setup>
import Modal from '@/Components/Modal.vue'
import { useDesignSystem } from '@/composables/designSystem'
import { useInertiaError } from '@/composables/useInertiaError'
import Vapor from 'laravel-vapor'

const { showError, isTablePage, hide } = useInertiaError()

const designSystem = useDesignSystem()
</script>
